/**
 * MCK Custom Cursor Fix
 * 
 * Overrides the Impact theme's custom cursor behavior to prevent unwanted page
 * scroll in the "Thumbnails Bottom" gallery layout.
 * 
 * The original theme cursor uses translate positioning which can trigger
 * browser scroll when the cursor moves near container boundaries. This fix
 * uses position:fixed and viewport-relative coordinates instead.
 */
(function () {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMckCursor);
    } else {
        // Small delay to ensure theme's JS has run first
        setTimeout(initMckCursor, 100);
    }

    function initMckCursor() {
        // Find all product gallery cursor elements
        const cursors = document.querySelectorAll('.product-gallery__cursor');

        cursors.forEach(cursor => {
            const wrapper = cursor.closest('.product-gallery__media-list-wrapper');
            if (!wrapper) return;

            // Store reference to prevent duplicate initialization
            if (cursor.dataset.mckFixed === 'true') return;
            cursor.dataset.mckFixed = 'true';

            // Handle pointer movement with fixed positioning
            wrapper.addEventListener('pointermove', (event) => {
                // Skip if hovering over buttons or links
                if (event.target.matches('button, a[href], button *, a[href] *')) {
                    cursor.classList.remove('is-visible');
                    return;
                }

                const wrapperRect = wrapper.getBoundingClientRect();

                // Check if mouse is within wrapper bounds
                const isInBounds = (
                    event.clientX >= wrapperRect.left &&
                    event.clientX <= wrapperRect.right &&
                    event.clientY >= wrapperRect.top &&
                    event.clientY <= wrapperRect.bottom
                );

                if (isInBounds) {
                    // Get cursor dimensions (fallback to 48px if not rendered yet)
                    const cursorWidth = cursor.offsetWidth || 48;
                    const cursorHeight = cursor.offsetHeight || 48;

                    // Calculate cursor position (centered on mouse)
                    const cursorX = event.clientX - cursorWidth / 2;
                    const cursorY = event.clientY - cursorHeight / 2;

                    // Apply fixed positioning directly via style attribute
                    // This overrides both CSS and theme's inline styles
                    cursor.setAttribute('style', `
            position: fixed !important;
            left: ${cursorX}px !important;
            top: ${cursorY}px !important;
            transform: none !important;
            translate: none !important;
            pointer-events: none;
            z-index: 100;
          `);

                    // Determine which half of the gallery we're on (for arrow direction)
                    const wrapperXCenter = (wrapperRect.left + wrapperRect.right) / 2;
                    const isOnStartHalf = event.clientX < wrapperXCenter;

                    cursor.classList.toggle('is-half-start', isOnStartHalf);
                    cursor.classList.toggle('is-half-end', !isOnStartHalf);
                    cursor.classList.add('is-visible');
                } else {
                    cursor.classList.remove('is-visible');
                }
            }, { passive: true });

            // Handle pointer leaving the wrapper
            wrapper.addEventListener('pointerleave', () => {
                cursor.classList.remove('is-visible', 'is-half-start', 'is-half-end');
            });
        });
    }
})();
